import React, { useState } from "react";
import { Link } from "react-router-dom";

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import folderGreenIcon from "./../../../../assets/img/DashboardICons/folderGreenIcon.svg";
import peopleGreenIcon from "./../../../../assets/img/DashboardICons/peopleGreenIcon.svg";

const StaffManagmentFiles = ({ dashboardData, userCount }) => {

    return (
        <div dir="rtl" className={`mt-3 pt-2 mx-4 px-2 d-flex justify-content-between`}>
            <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap`}>

                <div className={`d-flex align-items-start justify-content-start ${styles.total_counts_box} ${styles.total_staff_counts_box}`}>
                    <div className={`bg-white p-2 d-flex align-items-center justify-content-center ${styles.total_icons_counts_box}`}>
                        <img src={peopleGreenIcon} alt="people-green-icon" />
                    </div>
                    <div className={`me-4 text-right`}>
                        <h5 className={`pt-1 pb-1 ${styles.total_title_counts_box}`}> تعداد پرسنل </h5>
                        <h4 className={`mb-0 ${styles.total_subTitle_counts_box}`}>
                            {userCount?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                        </h4>
                    </div>
                    <div className="d-flex align-self-end me-auto">
                        <Link to="/staff-managment-colleagues-info" style={{ color: "#21409a" }}>
                            مشاهده
                            <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="29" />
                        </Link>
                    </div>
                </div>

                <div className={`d-flex align-items-start justify-content-start ${styles.total_counts_box} ${styles.total_files_counts_box}`}>
                    <div className={`bg-white p-2 d-flex align-items-center justify-content-center ${styles.total_icons_counts_box}`}>
                        <img src={folderGreenIcon} alt="folder-green-icon" />
                    </div>
                    <div className={`me-4 text-right`}>
                        <h5 className={`pt-1 pb-1 ${styles.total_title_counts_box}`}> تعداد فایل ها </h5>
                        <h4 className={`mb-0 ${styles.total_subTitle_counts_box}`}>
                            {dashboardData?.estateCount?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                        </h4>
                    </div>
                    <div className="me-auto">
                        <div className="d-flex justify-content-start align-items-center">
                            <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#127442" }}></i>
                            <span className={`pe-2 text-right ${styles.total_title_file_box}`}> فعال </span>
                            <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                                {dashboardData?.activeCount?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            </span>
                        </div>
                        <div className="my-1 py-1 d-flex justify-content-start align-items-center">
                            <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#E7CF00" }}></i>
                            <span className={`pe-2 text-right ${styles.total_title_file_box}`}> آرشیو </span>
                            <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                                {dashboardData?.archivedCount?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            </span>
                        </div>
                        <div className="my-1 py-1 d-flex justify-content-start align-items-center">
                            <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#127442" }}></i>
                            <span className={`pe-2 text-right ${styles.total_title_file_box}`}> پیش نویس </span>
                            <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                                {dashboardData?.draftCount?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default StaffManagmentFiles;